<ng-container>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">Run Tests</h5>
  </div>
  <div class="modal-body" ngbAutofocus>
    <div class="form-row">
      <div class="col-12">
        <app-dc-checkbox 
            [formControl]="refresh" 
            label="Refresh product analytics before running tests?">
        </app-dc-checkbox>
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-right">
    <button type="button" class="btn btn-secondary btn-sm" (click)="cancel()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary btn-sm"
      (click)="save()"
    >
      Run
    </button>
  </div>
</ng-container>
